import { Component } from 'solid-js'

import './style/loadingdots.scss'

export const LoadingDots: Component<{}> = () => {
    return (
        <div class='loading-dots-cmp'>
            <span class='dot'></span>
            <span class='dot'></span>
            <span class='dot'></span>
        </div>
    )
}
